import { Component, OnInit } from '@angular/core';
import { AutomationService } from '../automation.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'userinfo-nil-transformation',
    templateUrl: './userinfo-nil-transformation.component.html',
    styleUrls: ['./userinfo-nil-transformation.component.css']
})
export class UserInfoNilTransformation implements OnInit {

    public sheets: any[] = [];

    public password: string = '';

    public errorOverLay;

    public userInfoResponse: string;

    public form: FormGroup;

    public somethingToCopy: boolean;

    public lastValidRespone: string;


    constructor(private automationService: AutomationService, private formBuilder: FormBuilder) { }

    public ngOnInit() {
        this.form = new FormGroup({
            'nilResponse': new FormControl('', Validators.required),
            'userInfoResponse': new FormControl(''),
        });
        if (document.getElementById('userInfoResponse')) {
            document.getElementById('userInfoResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
        }
        this.form.controls.nilResponse.valueChanges.subscribe(() => {
            if (document.getElementById('userInfoResponse')) {
                document.getElementById('userInfoResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
            }

        })
    }


    public startTransformation() {

        let nilJSON;
        let validNILJson: boolean = false;
        const pre = document.createElement('pre');

        this.somethingToCopy = false;
        pre.style.height = '700px';
        if (document.getElementById('userInfoResponse')) {
            document.getElementById('userInfoResponse').innerHTML = '';
        }

        try {
            nilJSON = JSON.parse(this.form.controls.nilResponse.value);
            validNILJson = true;
        } catch (error) {
            this.errorOverLay = {
                message: 'Invalid JSON For NIL<br/>' + error,
            };

            if (document.getElementById('userInfoResponse')) {
                document.getElementById('userInfoResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
            }
        }

        if (validNILJson) {
            if (nilJSON.userAccountVBO || (nilJSON.mobileContractArray || nilJSON.fixednetContractArray || nilJSON.cableContractArray)) {
                this.automationService.TransformJSON(nilJSON).subscribe((json) => {
                    const stringifiedJSON = JSON.stringify(json, null, 2);
                    document.getElementById('userInfoResponse').appendChild(pre).innerHTML = this.automationService.pretifyJson(stringifiedJSON);
                    this.lastValidRespone = stringifiedJSON;
                    this.somethingToCopy = true;
                }, (error) => {
                    // this.errorOverLay = {
                    //     message: 'Transformation To User Info Failed <br/>' + (error.json ? error.json().message : error),
                    // };

                    if (document.getElementById('userInfoResponse')) {
                        document.getElementById('userInfoResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
                    }
                });
            } else {

                this.errorOverLay = {
                    message: `Invalid NIL Response`,
                };

                if (document.getElementById('userInfoResponse')) {
                    document.getElementById('userInfoResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
                }
            }

        }
    }

    public copyToClipBoard() {

        this.automationService.copyToClipboard(this.lastValidRespone).then(function () {
            console.log('Copying to clipboard was successful!');
        }, function (error) {
            this.errorOverLay = {
                message: 'Cannot Copy To Clip Board <br/>' + error,
            };
        });
    }

    public closeOverLay() {

        this.errorOverLay = null;
    }

    public onPasteNil() {

        setTimeout(() => {
            if (document.getElementById('userInfoResponse')) {
                document.getElementById('userInfoResponse').innerHTML = 'Click Start Transformation In order to see User Info Response Here';
            }
            document.getElementById("nil-response") && document.getElementById("nil-response").scroll(0, 0);
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/userinfo-nil-transformation/userinfo-nil-transformation.component.ts